import React, { useState } from "react";
import style from "@/styles/LPMoveBrasilDefesa.module.scss";

export default function Defesas() {
	const Defesa = [
		[
			"KYOTO MOVE BRASIL ",
			`Ofertas válidas para as lojas Kyoto Toyota presentes no estado do Distrito Federal, exclusivas para TAXISTAS (conforme critérios de elegibilidade do Programa Move Brasil do Governo Federal, aplicável a veículos de até R$ 150 mil) e MOTORISTAS DE APLICATIVO elegíveis ao Programa Move Brasil. Condições especiais de financiamento com taxas reduzidas, 6 meses de carência e planos de até 72x. Condições do financiamento sujeitas à aprovação de crédito pelas instituições financeiras participantes, com início das operações e abertura de crédito a partir de 19/06/2026, data em que se iniciam os faturamentos desta modalidade. Pedidos inseridos entre 19 de junho de 2026 e 31 de julho de 2026 ou até durarem os estoques. TOYOTA YARIS CROSS XR, 0km, ano/modelo 2026/2026, cor branco sólido, para Motoristas de Aplicativo, a partir de R$ 149.990,00 por R$ 134.991,00 à vista (desconto de 10% concedido pela montadora sobre o preço público do veículo, sem aplicação de isenções fiscais). TOYOTA YARIS CROSS XR, 0km, ano/modelo 2026/2026, cor branco sólido, para Taxistas elegíveis com isenções integrais, a partir de R$ 149.990,00 por R$ 112.480,63 à vista (desconto de 10% concedido pela montadora + isenção de IPI + isenção de ICMS aplicados sob o preço público do veículo, válidos para a modalidade Taxista com isenções integrais). Os benefícios financeiros do Programa Move Brasil (condições especiais de financiamento, taxas reduzidas, carência de até 6 meses e prazo de até 72 meses) são válidos para ambos os públicos elegíveis, observadas as condições do programa e aprovação de crédito. Preços sujeitos a reajuste até a data do faturamento. A Garantia Toyota 10 será renovada por novos períodos de 12 meses ou 10.000 km, o que ocorrer primeiro, até o limite máximo de 10 anos ou 200.000 km em caso de uso particular, ou 100.000 km em caso de uso comercial, mediante a realização das revisões periódicas na Rede de Concessionárias Autorizadas Toyota, conforme o Manual do Proprietário.`,
		],
	];

	const [openIndex, setOpenIndex] = useState<number | null>(null);

	function handleDropdownClick(index: number) {
		setOpenIndex((prev) => (prev === index ? null : index));
	}

	return (
		<>
			<h3 className={style["defesa-title"]}>
				CONDIÇÕES DA OFERTA E GARANTIA
			</h3>
			<div className={style["defesa-content"]}>
				{Defesa.map((item, index) => {
					const isOpen = openIndex === index;
					return (
						<div key={index} className={style["defesa-item"]}>
							<button
								className={style["defesa-dropdown-button"]}
								onClick={() => handleDropdownClick(index)}
							>
								{item[0]}
								<span
									style={{
										display: "inline-block",
										marginLeft: 8,
										transition: "transform 0.3s",
										transform: isOpen
											? "rotate(90deg)"
											: "rotate(0deg)",
									}}
								>
									&#8250;
								</span>
							</button>
							{isOpen && (
								<p className={style["defesa-text"]}>
									{item[1]}
								</p>
							)}
						</div>
					);
				})}
			</div>
		</>
	);
}
